import { useToast } from '@repo/design-system/index'
import { QIcon_chevron_bold_left } from '@repo/icons/index'
import { ActivityComponentType } from '@stackflow/react'
import { useQueryClient } from '@tanstack/react-query'
import { ReactNode, useEffect, useState } from 'react'
import apis from '../../../modules/apis'
import { useUpcomingsV5 } from '../../../modules/apis/common/user'
import { axiosGet, axiosPost } from '../../../modules/axiosHelper'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useWebviewNavigation from '../../../modules/hooks/webview/common/useWebviewNavigation'
import { s_upcoming_lessons } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { COLORS } from '../../../modules/vars'
import { useLessonsStack } from '../../../pages/[lang]/webview/lessons'
import ChangeMatchingOptionModal from '../../student/new-portal/lessons/UpcomingLessonCard/ChangeMatchingOptionModal'
import WebviewStackContainer from '../common/WebviewStackContainer'

interface IUpcomingLessonOptionBar {
  pop: any
  title: string | ReactNode
  search?: ReactNode
}

export const UpcomingLessonOptionBar = ({ pop, title, search }: IUpcomingLessonOptionBar) => {
  return (
    <div className="flex h-[52px] w-full items-start justify-between pt-[16px] pl-[12px]">
      <div className="mr-auto flex" onClick={() => pop()}>
        <QIcon_chevron_bold_left width={20} height={20} color={COLORS.GRAY700} />
      </div>
      <div className="text-[16px] font-medium text-black">{title}</div>
      <div className="ml-auto">{search && search}</div>
    </div>
  )
}

interface ITutorMatchingOptionChange {
  params: {
    lessonId: string
  }
}

const TutorMatchingOptionChangeActivity: ActivityComponentType = ({ params }: ITutorMatchingOptionChange) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { toastSuccess } = useToast()
  const [settingData, setData] = useState(null)
  const [filteredItem, setFilteredItem] = useState(null)
  const router = useAppRouter()
  const lessonId = params?.lessonId ? params.lessonId : router.query.lessonId
  const { popBackToRingleApp } = useWebviewNavigation()

  // data filtering
  const { data } = useUpcomingsV5()

  // API call
  const fetchData = async () => {
    const response = await axiosGet(apis.lessons.preparation.option(lessonId))

    if (response) {
      setData(response)
    }
  }

  useEffect(() => {
    if (data) {
      console.log(data.upcoming_lessons.find((item) => item.id === Number(lessonId)))
      setFilteredItem(data.upcoming_lessons.find((item) => item.id === Number(lessonId)))
      fetchData()
    }
  }, [data])

  const handleSubmitWebview = async (e, option) => {
    e.preventDefault()
    const response = await axiosPost(apis.lessons.preparation.option(lessonId), {
      option: option,
    })
    if (response.success) {
      queryClient.invalidateQueries([apis.lessons.upcomingsV5()])
      toastSuccess(t(s_upcoming_lessons.after_tutor_cancel.your_option_change_has_been_completed))

      setTimeout(() => {
        popBackToRingleApp()
      }, 3000)
    } else {
      alert(response.message)
    }
    e.stopPropagation()
  }

  return (
    <WebviewStackContainer onBack={pop} title="튜터 매칭 옵션 변경">
      {filteredItem && (
        <ChangeMatchingOptionModal
          isBooked={settingData?.is_booked_time}
          lesson={data.upcoming_lessons.find((item) => item.id === Number(lessonId))}
          onHide={() => {
            console.log('tutor matching hide')
          }}
          onChangeOptionOnWebview={handleSubmitWebview}
        />
      )}
    </WebviewStackContainer>
  )
}

export default TutorMatchingOptionChangeActivity
